import React from 'react';

export const PartlyDisabledInfo = () => (
  <>
    <div className="partly-disabled-info">
      <h4>Pro rato</h4>
      <p>De uitkering is afhankelijk van de mate van arbeidsongeschiktheid. Bent u gedeeltelijk arbeidsongeschikt? Dan krijgt u een gedeelte van het verzekerd maandbedrag. Bent u meer dan 80% arbeidsongeschikt? Dan ontvangt u het volledige verzekerd maandbedrag.</p>
    </div>
    <div className="partly-disabled-info">
      <h4>Volledige uitkering</h4>
      <p>Als u meer dan 35% arbeidsongeschikt bent, ontvangt u het volledige verzekerd maandbedrag.</p>
    </div>
  </>
);
